import React from "react";
import Header from "../../components/common/Header";
import Sidebar from "../../components/common/Sidebar";
import Footer from "../../components/common/Footer";
import SecurityMain from "../../components/settings/security/SecurityMain";
import { RODEO_PAGE_NAME } from "../../_config";

const SecurityContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.SETTINGS_SECURITY} showSettingsSidebar={true} />
      <SecurityMain />
      <Footer variant="dashboard" />
    </>
  );
};

export default SecurityContainer;
